export default __webpack_public_path__ + "images/QL.ad11933.png";